import React from 'react';
import { DownloadCloud, PackagePlus, Zap, TrendingUp } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      id: "01",
      title: "Download App",
      desc: "Download from Play Store. Takes less than 2 minutes to install.",
      icon: <DownloadCloud className="text-emerald-600" size={28} />,
    },
    {
      id: "02",
      title: "Add Your Products",
      desc: "Scan barcodes or add manually. We also help you setup for free.",
      icon: <PackagePlus className="text-emerald-600" size={28} />,
    },
    {
      id: "03",
      title: "Start Billing",
      desc: "Begin using immediately. Your first bill in under 30 seconds.",
      icon: <Zap className="text-emerald-600" size={28} />,
    },
    {
      id: "04",
      title: "Watch Business Grow",
      desc: "Track sales, manage customers, and see your profits increase.",
      icon: <TrendingUp className="text-emerald-600" size={28} />,
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-20">
          <h2 className="text-emerald-600 font-bold uppercase tracking-widest text-sm mb-3">How it works</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Start in Just <span className="text-emerald-600">5 Minutes</span>
          </h3>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            No complicated setup. No technical knowledge needed. Start using RetailMitra today.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 relative">
          {/* Connector Line (Desktop Only) */}
          <div className="hidden lg:block absolute top-1/4 left-0 w-full h-0.5 bg-slate-100 -z-0"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative group text-center lg:text-left">
              {/* Step Number Background */}
              <div className="text-8xl font-black text-slate-50 absolute -top-10 left-1/2 lg:left-0 -translate-x-1/2 lg:translate-x-0 select-none -z-10 group-hover:text-emerald-50 transition-colors">
                {step.id}
              </div>

              {/* Icon Circle */}
              <div className="relative z-10 w-20 h-20 bg-white border-4 border-white shadow-xl rounded-3xl flex items-center justify-center mb-8 mx-auto lg:mx-0 group-hover:scale-110 transition-transform duration-300">
                <div className="w-14 h-14 bg-emerald-50 rounded-2xl flex items-center justify-center">
                  {step.icon}
                </div>
              </div>

              {/* Content */}
              <div className="relative z-10 px-4 lg:px-0">
                <h4 className="text-xl font-bold text-slate-900 mb-3">{step.title}</h4>
                <p className="text-gray-600 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Help Banner from Video */}
        <div className="mt-20 bg-emerald-900 rounded-[2rem] p-8 md:p-12 text-center text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-64 h-64 bg-emerald-800 rounded-full blur-3xl opacity-50"></div>
          
          <h4 className="text-2xl md:text-3xl font-bold mb-4 relative z-10">Need Help Getting Started?</h4>
          <p className="text-emerald-100 mb-8 relative z-10 text-lg">
            Our team will help you set up your entire product catalog for <span className="font-bold text-white uppercase tracking-wider">Free</span>. Just call us!
          </p>
          <div className="inline-flex items-center gap-4 bg-white text-emerald-900 px-8 py-4 rounded-2xl font-black text-xl md:text-2xl shadow-xl hover:scale-105 transition-transform cursor-pointer relative z-10">
            📞 8210345655 / 9163091507
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;